import callApi from '../utils/api';

export const createFile = async (uploadType: string) => {
  const settings = {
    endpoint: `upload/create?uploadType=${uploadType}`,
    options: {
      method: 'POST',
      errorMessage: `Failed to create file`,
      data: {},
    },
  };
  try {
    const { data } = await callApi(settings);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const appendFile = async (
  uniqueIdentifier: string,
  offset: number,
  file: File,
  uploadType: string
) => {
  const settings = {
    endpoint: `upload/append?uniqueIdentifier=${uniqueIdentifier}&offset=${offset}&uploadType=${uploadType}`,
    options: {
      method: 'POST',
      errorMessage: `Failed to append file`,
      data: file,
      formData: true,
    },
  };

  try {
    const data = await callApi(settings);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const flushFile = async (
  uniqueIdentifier: string,
  position: number,
  uploadType: string
) => {
  const settings = {
    endpoint: `upload/flush?uniqueIdentifier=${uniqueIdentifier}&position=${position}&uploadType=${uploadType}`,
    options: {
      method: 'POST',
      errorMessage: `Failed to flush file`,
      data: {},
    },
  };
  try {
    const data = await callApi(settings);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};
